export default __webpack_public_path__ + "static/media/ni.e68a107d.svg";